/* eslint-disable react/no-array-index-key */
import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { APIgetCollections } from '../../api/Collections';

import CollectionsGridItem from '../Collections/GridItemV2';
import DashboardWidgetPlaceholderCollection from './WidgetPlaceholderCollection';
import DashboardWidgetSkeletonCollection from './WidgetSkeletonCollection';

import { getDashboardComponentSettings } from '../../helpers/Dashboard';

const DashboardWidgetFeaturedCollections = () => {
  const intl = useIntl();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [rowHeight, setRowHeight] = useState(null);

  const containerRef = useRef(null);

  const componentSetting = getDashboardComponentSettings('favorite-collections');
  const rowCount = componentSetting ? componentSetting.h : 1;

  const loadItems = useCallback((page = 1) => {
    APIgetCollections(null, {
      favorites: true,
      page,
      per_page: 18,
    }).then(response => {
      setItems(response.data.data.data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  const handleChangeRowHeight = useCallback(() => {
    if (containerRef.current) {
      const computedStyle = window.getComputedStyle(containerRef.current);
      const gap = parseFloat(computedStyle.getPropertyValue('row-gap'));

      let firstChildHeight = 0;
      const firstChild = containerRef.current.firstElementChild;
      if (firstChild) {
        firstChildHeight = parseFloat(window.getComputedStyle(firstChild).getPropertyValue('height'));
      }

      setRowHeight((firstChildHeight * rowCount) + (gap * rowCount) - 1);
    }
  }, [rowCount]);

  useEffect(() => {
    handleChangeRowHeight();
  }, [handleChangeRowHeight]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(handleChangeRowHeight);

    const dashboard = document.querySelector(`.dashboard-content`);

    resizeObserver.observe(dashboard);

    return () => {
      resizeObserver.unobserve(dashboard);
    };
  }, [handleChangeRowHeight]);

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div>
          <h3>{intl.formatMessage({ defaultMessage: 'Favorite Collections' })}</h3>
          <Link to="/favorites">
            <span>{intl.formatMessage({ defaultMessage: 'See all' })}</span>
          </Link>
        </div>
      </div>
      <div className="dashboard-section-content">
        <div className="dashboard-section-recent-collections-wrapper collections" ref={containerRef} style={{ height: rowHeight || 'unset' }}>
          {!loading && items.map(c => (
            <CollectionsGridItem
              id={c.uuid}
              index={c.uuid}
              key={c.uuid}
              collection={c}
              moveCollection={() => {}}
              saveCollections={() => {}}
              handleMoveSelectedItems={() => {}}
              isMoved={false}
              canDrag={false}
              allowCheck={false}
            />
          ))}
          {loading ?
            [...Array(18)].map((_, i) => <DashboardWidgetSkeletonCollection key={i} />) :
            (items.length < 18 && items.length > 0) && [...Array(18 - items.length)].map((_, i) => <DashboardWidgetPlaceholderCollection key={`dp-${i}`} />)}
          {(!loading && items.length === 0) && (
            <p className="dashboard-section-not-found-message">{intl.formatMessage({ defaultMessage: 'You don\'t have any favorite Collections yet' })}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardWidgetFeaturedCollections;
